// src/components/common/ReAuthWrapper.jsx
import React from 'react';
import ReAuthModal from '../auth/ReAuthModal';
import useReAuth from '../../hooks/useReAuth';

const ReAuthWrapper = ({ children }) => {
  const {
    showReAuthModal,
    handleReAuthSuccess,
    handleReAuthCancel,
    pendingActionType
  } = useReAuth();

  return (
    <>
      {children}
      <ReAuthModal
        isOpen={showReAuthModal}
        onClose={handleReAuthCancel}
        onSuccess={handleReAuthSuccess}
        actionType={pendingActionType}
      />
    </>
  );
};

export default ReAuthWrapper;
